import { FC, ReactElement } from 'react';
import { useBreakpoints } from '../../bookings/util/useBreakpoints';
import { useDesktopTopNav } from '../../common/Experiments/DesktopTopNavExperiment';
import { useHomepageTiles } from '../../common/Experiments/HomepageTilesExperiment';
import { HeaderLayout } from '../../common/components/SearchHeader/HeaderLayout/HeaderLayout';
import { SearchPromotionItem } from '../../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';

interface HomepageHeaderLayoutProps {
  onClearSearch?: VoidFunction;
  searchSpecialty?: SearchPromotionItem | null;
  banner: ReactElement;
}

export const HomepageHeaderLayout: FC<HomepageHeaderLayoutProps> = ({
  onClearSearch,
  searchSpecialty,
  banner,
}) => {
  const breakpoints = useBreakpoints();
  const tilesExperiment = useHomepageTiles();
  const topNavExperiment = useDesktopTopNav();

  return (
    <HeaderLayout
      compactSearch={breakpoints.Small}
      disableSearch={!breakpoints.Small && !tilesExperiment}
      onClearSearch={onClearSearch}
      searchSpecialty={searchSpecialty}
      showLoginDropdown
      banner={banner}
      topNavExperiment={topNavExperiment}
    />
  );
};
